// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { CancellazioniPartecipoDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class CancellazioniPartecipoApiClient extends BaseCRUDApiClient<CancellazioniPartecipoDto> {
  baseUrl = this.config.apiEndpoint + '/cancellazioni-partecipo';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
